import Badge from '@components/Badge';
import { EventRow } from '@models/event';
import { EventStatusBadgeColor } from '@models/event/extension';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import BoardCard from '../../BoardCard';

interface Props {
    event: EventRow;
}

function EventItem({ event }:Props) {
    const {
        id, status, startAt, endAt, listBannerImageUrl, title, contentSummary, isPinned,
    } = event;
    const { t } = useTranslation('board');

    return (
        <BoardCard activityName='EventActivity'
            activityParams={{ eventId: id }}
            badge={(
                <Badge color={EventStatusBadgeColor[status]}>
                    {t(`eventStatus.${status}`)}
                </Badge>
            )}
            meta={`${dayjs(startAt).format('YYYY.MM.DD')} ~ ${dayjs(endAt).format('YYYY.MM.DD')}`}
            isPinned={isPinned}
            title={title}
            imageUrl={listBannerImageUrl}
            imageAlt={t('eventImageAlt')}
            summaryHtml={contentSummary} />
    );
}

export default EventItem;
